import { render, staticRenderFns } from "./TextPageCreate.vue?vue&type=template&id=52704cf4&scoped=true&"
import script from "./TextPageCreate.vue?vue&type=script&lang=js&"
export * from "./TextPageCreate.vue?vue&type=script&lang=js&"
import style0 from "./TextPageCreate.vue?vue&type=style&index=0&id=52704cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52704cf4",
  null
  
)

export default component.exports